module.exports = __webpack_public_path__ + "img/1.37a15b2a.png";